export default [
  {
    path: 'profile',
    component: () => import('@/App.vue'),
    meta: {
      title: 'Profile',
      sort: 6,
      authenticatable: true,
      icon: 'mdi-flask',
    },
    children: [
      {
        path: '',
        props: true,
        name: 'myprofile',
        component: () => import('../Profile.vue'),
        meta: {
          title: 'Profile',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask',
        },
      },
      {
        path: 'changepassword',
        props: true,
        name: 'changepassword',
        component: () => import('../ChangePassword.vue'),
        meta: {
          title: 'Change Password',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask',
        },
      },
      {
        path: 'forgotpassword',
        props: true,
        name: 'forgotpassword',
        component: () => import('../ForgotPassword.vue'),
        meta: {
          title: 'Forgot Password',
          sort: 6,
          authenticatable: true,
          icon: 'mdi-flask',
        },
      },
      {
        path: 'edit',
        name: 'profile.edit',
        component: () => import('../Edit.vue'),
        meta: {
          title: 'Update Profile',
          sort: 9,
          authenticatable: true,
        },
      },
    ],
  }
]
